import { Link, useNavigate } from 'react-router-dom'
import Logo from '../assets/logo.png'
import { UserIcon } from '../utils/icons'
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useGetAuthUserQuery, useRegisterUserMutation, useUpdateProfileMutation } from '../services/Api';

import { toast } from 'react-toastify';
import Button from '../components/button';
import { useEffect } from 'react';


const Updateprofile = () => {
    const navigate = useNavigate()
    const { data, isLoading: userLoading } = useGetAuthUserQuery();
    console.log("Update profile", data);

    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Required'),
        lastName: Yup.string()
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Required'),
        nationality: Yup.string(),
        phoneNumber: Yup.string()
        /* password: Yup.string()
            .required("Password is required")
            .min(8, "Password must be at least 8 characters")
            .matches(
                /^[^\s]+$/,
                "Password must not contain spaces"
            ), */
    });

    const {
        reset,
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onTouched",
        resolver: yupResolver(validationSchema),
    });

    const [updateProfile, { isLoading: updateProfileLoading, isError, isSuccess, error }] =
        useUpdateProfileMutation();


    const onSubmit = async (values) => {
        const data = {
            firstName: values?.firstName,
            lastName: values?.lastName,
            nationality: values?.nationality,
            phoneNumber: values?.phoneNumber,
        };

        updateProfile({ data }).unwrap()
            .then((payload) => {
                if (payload.success) {
                    toast.success("Profile updated Successfully");
                } else {
                    toast.error(payload?.message);
                }
            })
            .catch((error) => {
                toast.error(error?.data?.message);
            }).finally(() => {
                console.log("cloick");

            });
    };
    useEffect(() => {
        if (data) {
            reset({
                firstName: data.firstName,
                lastName: data.lastName,
                nationality: data.nationality,
                phoneNumber: data.phoneNumber,
            });
        }
    }, [data, reset]);

    return (
        <div className="">

            <div className="grid md:grid-cols-2 grid-cols-1 ">
                <div className="hidden md:block">
                    <div className="h-screen w-full flex justify-center items-center bg-bgprimary ">

                        <div className="max-w-[330px] mx-auto">
                            <div className="w-full bg-aths h-[350px]">
                                <img src={`https://images.pexels.com/photos/15141413/pexels-photo-15141413/free-photo-of-greek-flag-flying-over-the-sea.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1`} className='w-full h-full object-cover' alt="" />
                            </div>
                            <h2 className='text-dark font-roboto-mono font-bold italic text-[40px] text-center' >Our Mission</h2>
                            <p className='text-dark font-quicksand font-medium text-[11px] text-center' >
                                Our mission is to provide the modern traveler with an adsaptable travel ecosystem and information database that will suppirt them as a companion in their jorney of discoery
                            </p>
                        </div>
                    </div>
                </div>
                <div className="md:h-screen h-auto w-full flex md:px-8 px-4 md:py-2 pt-24 pb-8 items-center ">
                    <div className="w-full">
                        <h2 className='text-center text-3xl mb-4 font-bold'>EDIT PROFILE</h2>
                        <div className="w-full grid md:grid-cols-2 grid-cols-2 gap-3 ">
                            <div className="input_divs mb-3">
                                <h3 className='text-dark font-quicksand font-bold text-[20px] ' >Name</h3>
                                <input type="text" {...register("firstName")} className='w-full bg-transparent border border-dark px-5 py-2 text-dark font-quicksand font-bold text-[16px] placeholder:text-[#CDD0D4] mt-2 ' />
                                {errors.firstName && <p className='errorMsg mt-2'>{errors.firstName.message}</p>}
                            </div>
                            <div className="input_divs mb-3">
                                <h3 className='text-dark font-quicksand font-bold text-[20px] ' >Last Name</h3>
                                <input type="text" {...register("lastName")} className='w-full bg-transparent border border-dark px-5 py-2 text-dark font-quicksand font-bold text-[16px] placeholder:text-[#CDD0D4] mt-2 ' />
                                {errors.lastName && <p className='errorMsg mt-2'>{errors.lastName.message}</p>}
                            </div>
                            <div className="input_divs mb-3">
                                <h3 className='text-dark font-quicksand font-bold text-[20px] ' >Phone Number</h3>
                                <input type="text" {...register("phoneNumber")} className='w-full bg-transparent border border-dark px-5 py-2 text-dark font-quicksand font-bold text-[16px] placeholder:text-[#CDD0D4] mt-2 ' />
                                {errors.phoneNumber && <p className='errorMsg mt-2'>{errors.phoneNumber.message}</p>}
                            </div>

                            <div className="input_divs mb-3">
                                <h3 className='text-dark font-quicksand font-bold text-[20px] ' >Nationality</h3>
                                <input type="text" {...register("nationality")} className='w-full bg-transparent border border-dark px-5 py-2 text-dark font-quicksand font-bold text-[16px] placeholder:text-[#CDD0D4] mt-2 ' />
                            </div>

                        </div>

                        <Button label={`Update Record`} onClick={handleSubmit(onSubmit)} className='flex items-center gap-3 border-2 border-dark px-5 py-2 font-quicksand text-dark font-bold min-h-8 min-w-16 text-[16px] bg-white mb-5 ' loading={updateProfileLoading} />

                    </div>

                </div>

            </div>
        </div>
    )
}

export default Updateprofile
